export default {"src":"/_next/static/media/mainFill.207dbb4a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};